

import messages from 'vuetify/src/locale/ar.ts'

export default messages
